import { render, staticRenderFns } from "./CustomersDropdown.vue?vue&type=template&id=0b9c6d60&scoped=true"
import script from "./CustomersDropdown.vue?vue&type=script&lang=ts"
export * from "./CustomersDropdown.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9c6d60",
  null
  
)

export default component.exports